
























import {Vue, Component, Watch} from 'vue-property-decorator';
import AccountService from '@/services/account.service';
import {RouterHelper} from '@/router';
import {Action, Getter} from 'vuex-class';
import {Account, CommercialAccount} from '@/types';

@Component({})
export default class AccountSelect extends Vue {
  @Getter private activeAccountId!: any;
  @Getter private accounts!: any;
  @Action private addAccountsAsync: any;
  private selectedAccount: any = {};

  @Watch('selectedAccount')
  private onSelectedAccountChange() {
    if (!this.selectedAccount) {
      return;
    }
    this.onSelectedAccountChanged(this.selectedAccount);
  }

  private async mounted() {
    // this.accounts = await AccountService.getUserAccounts();
    if (!this.accounts.accounts.length) {
      this.addAccountsAsync();
    }
    this.selectedAccount = this.activeAccountId;
  }

  private get sortedAccounts() {
    const sortByName = (a: { id: number, name: string }, b: { id: number, name: string }) => {
      return a.name.localeCompare(b.name);
    };
    return this.accounts.accounts.slice().sort(sortByName);

  }
  private async onSelectedAccountChanged(id: string) {
    await RouterHelper.switchAccount(Number(id));
  }

}
